module.exports = __webpack_public_path__ + "static/media/52-golf.8dc1764c.jpeg";